/* app/js/src/components/calendar/calendar-grid-sec-events-popup/calendar-grid-sec-events-popup.component.scss */
.cursor-pointer {
  cursor: pointer;
}
.sec-events-popup {
  position: absolute;
  background: white;
  top: 100%;
  right: 13px;
  padding: 19px;
  box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.2);
  border: solid 1px #e1e6eb;
  -webkit-user-select: none;
  user-select: none;
  flex-direction: column;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  -webkit-align-items: stretch;
  -ms-flex-align: stretch;
  align-items: stretch;
  overflow: visible;
}
.sec-events-popup.active {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
}
.item-row {
  display: flex;
  position: relative;
}
.title-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 115px;
  padding-bottom: 4px;
}
.event-icon {
  display: flex;
  align-items: center;
  width: 22px;
}
.list-container {
  display: flex;
  flex-direction: row;
  padding-bottom: 4px;
}
.language {
  display: flex;
  align-items: center;
  text-transform: uppercase;
  font-size: 11px;
  color: #7b90a4;
  margin-right: 3px;
}
.language-container {
  -webkit-user-select: none;
  user-select: none;
}
.language {
  display: flex;
  align-items: center;
  text-transform: uppercase;
}
.item-name {
  display: flex;
}
.comma-hidden {
  display: none;
}
.events-table-header {
  height: 36px;
}
.type-header {
  width: 115px;
  font-size: 10px;
  font-weight: 700;
}
.name-header {
  min-width: 100px;
  font-size: 10px;
  font-weight: 700;
}
.duration-header {
  width: 84px;
  font-size: 10px;
  font-weight: 700;
}
.offset-header {
  font-size: 10px;
  font-weight: 700;
}
.type-text {
  display: flex;
  flex-direction: row;
  font-size: 12px;
  width: 115px;
  vertical-align: top;
  padding-bottom: 4px;
}
.name-text {
  font-size: 11px;
  color: #7b90a4;
  vertical-align: top;
  padding-bottom: 4px;
  padding-right: 5px;
}
.property-text {
  font-size: 11px;
  color: #7b90a4;
  vertical-align: top;
  padding-bottom: 4px;
}
.edit-button {
  display: block;
  border: 1px solid #2dbbfc;
  width: 56px;
  height: 27px;
  background: #ffffff;
  border: 1px solid #2dbbfc;
  box-sizing: border-box;
  border-radius: 3px;
  font-weight: bold;
  font-size: 10px;
  color: #2dbbfc;
  margin-top: 7px;
  margin-left: auto;
  margin-right: 0;
}
/*# sourceMappingURL=calendar-grid-sec-events-popup.component.css.map */
